import styled from "styled-components";
import { FormatDate } from "utils/formatters";

const CommentItem = ({ comment, secondary }: any) => {
  const profileUrl = comment?.facebookId
    ? `https://graph.facebook.com/${comment?.facebookId}/picture?type=normal`
    : "https://www.booksie.com/files/profiles/22/mr-anonymous_230x230.png";

  return (
    <Container key={comment.id}>
      {secondary && <Border />}
      <CommentContainer>
        <CommentUserContainer>
          <CommentUserIcon src={profileUrl} />
          <CommentUserNameContainer>
            <CommentUserName>{comment?.userFullName}</CommentUserName>
            <CommentUserDate>{FormatDate(comment?.createdAt)}</CommentUserDate>
          </CommentUserNameContainer>
        </CommentUserContainer>
        <CommentText secondary={secondary}>{comment?.comment}</CommentText>
      </CommentContainer>
    </Container>
  );
};

export default CommentItem;

const Container = styled.div<{showBorder?: boolean}>`
  display: flex;
`;

const CommentContainer = styled.div`
  display: grid;
`;

const CommentUserContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
`;

const Border = styled.div`
  background-color: #d4d4d4;
  height: 1px;
  width: 12px;
  margin-top: 25px;
  margin-right: 10px;
`;

const CommentUserNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 12px;
`;
const CommentUserName = styled.span`
  color: #222222;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;
const CommentUserDate = styled.span`
  color: #717171;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
`;
const CommentUserIcon = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

const CommentText = styled.span<{ secondary?: boolean }>`
  line-height: 24px;
  color: #222222;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: ${(props) => props.secondary && "20px"};
`;
